<template>
  <div>
    <vxe-grid
      ref="skuTable"
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      row-id="amzSkuCode"
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
      :radio-config="
        !multiple
          ? {
              trigger: 'row',
              highlight: highlight,
              strict: false,
              reserve: reserve,
            }
          : {}
      "
      :checkbox-config="
        multiple
          ? {
              trigger: 'row',
              highlight: highlight,
              reserve: reserve,
            }
          : {}
      "
      @radio-change="radioChange"
      @checkbox-change="checkboxChange"
      @checkbox-all="checkboxChange"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:hxSkuSalesChannel="{ row }">
        <el-tag
          v-if="row.v_hxSkuSalesChannel"
          size="mini"
          :type="
            row.hxSkuSalesChannel === 'H'
              ? 'success'
              : row.hxSkuSalesChannel === 'V'
              ? 'warning'
              : ''
          "
        >
          {{ row.v_hxSkuSalesChannel }}
        </el-tag>
      </template>
      <template v-slot:status="{ row }">
        <div>
          <el-tag
            size="mini"
            :type="
              row.hxPreOrderStatus === 'D' || row.hxPreOrderStatus === 'R'
                ? 'danger'
                : row.hxPreOrderStatus === 'Y'
                ? 'success'
                : row.hxPreOrderStatus === 'S'
                ? 'warning'
                : ''
            "
          >
            {{ row.v_hxPreOrderStatus }}
          </el-tag>
        </div>
      </template>
      <template v-slot:createInfo="{ row }">
        <span>{{ row.createByName }}</span>
        <br />
        <span>{{ row.createDate }}</span>
      </template>
      <template v-slot:modifyInfo="{ row }">
        <span>{{ row.modifyByName }}</span>
        <br />
        <span>{{ row.modifyDate }}</span>
      </template>
      <template v-slot:submitInfo="{ row }">
        <span>{{ row.submitByName }}</span>
        <br />
        <span>{{ row.submitTime }}</span>
      </template>
      <template v-slot:reviewInfo="{ row }">
        <span>{{ row.reviewByName }}</span>
        <br />
        <span>{{ row.reviewTime }}</span>
      </template>

      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import tableColumns from './table-columns'
import { format } from '@/libs/util.number.js'
export default {
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    tableHeight: { type: Number, default: 800 },
    multiple: { type: Boolean, default: false },
    reserve: { type: Boolean, default: false },
    highlight: { type: Boolean, default: true },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
      },
      tableColumns: tableColumns(this),
      format: (n) => format(n),
    }
  },
  methods: {
    checkboxChange({ records, reserves }) {
      this.$emit('choose-change', records.concat(reserves))
    },
    radioChange({ newValue }) {
      this.$emit('choose-change', newValue)
    },
  },
}
</script>
